/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Other_Languages_LabelInputs */

const en_other_languages_label = /** @type {(inputs: Other_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other languages`)
};

const de_other_languages_label = /** @type {(inputs: Other_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Sprachen`)
};

/**
* | output |
* | --- |
* | "Other languages" |
*
* @param {Other_Languages_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const other_languages_label = /** @type {((inputs?: Other_Languages_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Other_Languages_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_other_languages_label(inputs)
	return en_other_languages_label(inputs)
});